import { useState, useEffect } from 'react'
import { VITE_API_BASE as API_BASE } from '../config/apiConfig'

const PLATFORM_LOGOS = { douyin: '🎵', xiaohongshu: '📕', video: '🎬' }
const PLATFORM_NAMES = { douyin: '抖音', xiaohongshu: '小红书', video: '微信视频号' }
const STATUS_LABELS = { active: '已启用', inactive: '已停用', draft: '草稿', published: '已发布', publishing: '发布中', pending: '待发布' }
const STATUS_COLORS = { active: '#52c41a', inactive: '#999', draft: '#999', published: '#52c41a', publishing: '#1890ff', pending: '#fa8c16' }

export default function IPOperationsPage() {

// 创始人IP模板
const GROWTH_TEMPLATES = [
  { id: 'default', name: '经典回忆', desc: '简洁大方的经典风格', duration: '180秒', style: 'classic' },
  { id: 'cute', name: '可爱卡通', desc: '活泼可爱的卡通风格', duration: '150秒', style: 'cute' },
  { id: 'artistic', name: '艺术电影', desc: '电影感的艺术风格', duration: '200秒', style: 'artistic' },
  { id: 'growth', name: '成长足迹', desc: '记录成长的温馨风格', duration: '160秒', style: 'warm' },
  { id: 'dream', name: '梦想未来', desc: '充满希望的梦想风格', duration: '190秒', style: 'dreamy' },
]

// 活动执行方案模板
const ACTIVITY_TEMPLATES = [
  { id: 'CA01', name: '职业探索1日营', desc: '一大一小参与，体验不同职业', duration: '1天', phases: ['课前3天', '活动前1天', '活动当天', '活动后1天', '活动后7天'] },
  { id: 'CA02', name: '周末体验营', desc: '半日或1日活动', duration: '半天~1天', phases: ['课前准备', '活动当天', '活动回顾'] },
  { id: 'CB01', name: '假期特训营', desc: '3-5天集中训练营', duration: '3-5天', phases: ['入营', '每日活动', '结营展示'] },
]

const VIDEO_TEMPLATES = [
  { id: 'T01', name: '年度成长回顾', desc: '回顾孩子一整年的成长足迹', duration: '90秒', scenes: ['片头', '照片墙', '精彩时刻', '数据统计', '片尾'] },
  { id: 'T02', name: '活动精彩瞬间', desc: '展示单次活动的精彩照片', duration: '45秒', scenes: ['活动片头', '照片轮播', '活动片尾'] },
  { id: 'T03', name: '成就加冕', desc: '展示孩子获得的证书和成就', duration: '30秒', scenes: ['成就片头', '成就展示', '成就片尾'] },
  { id: 'T04', name: '毕业纪念', desc: '课程结业/毕业视频', duration: '60秒', scenes: ['毕业片头', '学习历程', '作品展示', '证书展示', '毕业片尾'] },
  { id: 'T05', name: '生日祝福', desc: '生日快乐视频', duration: '20秒', scenes: ['生日片头', '照片聚焦', '祝福语', '生日片尾'] },
  { id: 'T06', name: '成长足迹', desc: '按月份展示成长照片', duration: '60秒', scenes: ['足迹片头', '月度照片墙', '足迹片尾'] },
  { id: 'T07', name: '活动集锦', desc: '多活动精彩集锦（竖版）', duration: '30秒', scenes: ['集锦片头', '竖版轮播', '集锦片尾'] },
  { id: 'T08', name: '荣誉时刻', desc: '成就和证书展示（简洁版）', duration: '20秒', scenes: ['荣誉片头', '证书轮播', '荣誉片尾'] },
  { id: 'T09', name: '学习汇报', desc: '课程学习成果展示', duration: '45秒', scenes: ['学习片头', '进度展示', '作品画廊', '学习感想', '学习片尾'] },
  { id: 'T10', name: '感恩祝福', desc: '感谢祝福类视频（竖版）', duration: '15秒', scenes: ['感恩片头', '感恩内容', '感恩片尾'] },
]

const FOUNDER_TEMPLATES = [
  { id: 'story', name: '初心故事', desc: '分享创业初心和教育理念', duration: '60秒', scenes: ['开场白', '初心故事', '教育理念', '结尾呼吁'] },
  { id: 'qa', name: '家长问答', desc: '解答家长常见问题', duration: '45秒', scenes: ['问题引入', '专业解答', '案例分享', '引导咨询'] },
  { id: 'daily', name: '幕后日常', desc: '展示教学/备课场景', duration: '20秒', scenes: ['场景展示', '互动对话', '金句输出'] },
  { id: 'festival', name: '节日祝福', desc: '节日问候和应景内容', duration: '15秒', scenes: ['节日问候', '祝福语', '活动引导'] },
  { id: 'honor', name: '荣誉时刻', desc: '分享获奖和成就', duration: '30秒', scenes: ['荣誉展示', '背后故事', '感恩致谢'] },
  { id: 'course', name: '课程介绍', desc: '介绍课程体系和特色', duration: '45秒', scenes: ['痛点引入', '解决方案', '课程特色', '成功案例', '引导报名'] },
  { id: 'feedback', name: '家长反馈', desc: '展示家长真实评价', duration: '30秒', scenes: ['家长感言', '创始人点评', '信任背书'] },
  { id: 'growth', name: '成长分享', desc: '分享孩子进步故事', duration: '60秒', scenes: ['成长前后对比', '学习过程', '收获感悟', '鼓励其他家长'] },
]


  const [activeTab, setActiveTab] = useState('platforms')
  const [platforms, setPlatforms] = useState([])
  const [materials, setMaterials] = useState([])
  const [contents, setContents] = useState([])
  const [showAddPlatform, setShowAddPlatform] = useState(false)
  const [showAddMaterial, setShowAddMaterial] = useState(false)
  const [showAddContent, setShowAddContent] = useState(false)
  const [platformForm, setPlatformForm] = useState({ platform: 'douyin', name: '', app_id: '', app_secret: '', status: 'active' })
  const [materialForm, setMaterialForm] = useState({ title: '', type: 'video', tags: '' })
  const [contentForm, setContentForm] = useState({ title: '', description: '', platforms: [], material_id: '', content_type: 'video' })
  const [uploadFile, setUploadFile] = useState(null)
  const [showTemplates, setShowTemplates] = useState(false)
  const [selectedTemplate, setSelectedTemplate] = useState(null)

  const loadPlatforms = async () => {
    try {
      const res = await fetch(API_BASE + '/ip-operations/platforms')
      const data = await res.json()
      if (data.success) setPlatforms(data.data)
    } catch (e) { console.error(e) }
  }
  const loadMaterials = async () => {
    try {
      const res = await fetch(API_BASE + '/ip-operations/materials')
      const data = await res.json()
      if (data.success) setMaterials(data.data)
    } catch (e) { console.error(e) }
  }
  const loadContents = async () => {
    try {
      const res = await fetch(API_BASE + '/ip-operations/contents')
      const data = await res.json()
      if (data.success) setContents(data.data)
    } catch (e) { console.error(e) }
  }

  useEffect(() => { loadPlatforms(); loadMaterials(); loadContents() }, [])

  const handleAddPlatform = async () => {
    try {
      const res = await fetch(API_BASE + '/ip-operations/platforms', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(platformForm)
      })
      const data = await res.json()
      if (data.success) { setShowAddPlatform(false); setPlatformForm({ platform: 'douyin', name: '', app_id: '', app_secret: '', status: 'active' }); loadPlatforms() }
      else alert(data.error || '添加失败')
    } catch (e) { alert('添加失败') }
  }
  const handleDeletePlatform = async (id) => {
    if (!confirm('确定删除？')) return
    await fetch(API_BASE + '/ip-operations/platforms/' + id, { method: 'DELETE' })
    loadPlatforms()
  }
  const handleUploadMaterial = async () => {
    if (!uploadFile) { alert('请选择文件'); return }
    const formData = new FormData()
    formData.append('file', uploadFile)
    formData.append('title', materialForm.title)
    formData.append('type', materialForm.type)
    formData.append('tags', materialForm.tags)
    try {
      const res = await fetch(API_BASE + '/ip-operations/materials', { method: 'POST', body: formData })
      const data = await res.json()
      if (data.success) { setShowAddMaterial(false); setMaterialForm({ title: '', type: 'video', tags: '' }); setUploadFile(null); loadMaterials() }
      else alert(data.error || '上传失败')
    } catch (e) { alert('上传失败') }
  }
  const handleDeleteMaterial = async (id) => {
    if (!confirm('确定删除？')) return
    await fetch(API_BASE + '/ip-operations/materials/' + id, { method: 'DELETE' })
    loadMaterials()
  }
  const handleCreateContent = async () => {
    if (!contentForm.title) { alert('请输入标题'); return }
    if (contentForm.platforms.length === 0) { alert('请选择至少一个平台'); return }
    try {
      const res = await fetch(API_BASE + '/ip-operations/contents', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(contentForm)
      })
      const data = await res.json()
      if (data.success) { setShowAddContent(false); setContentForm({ title: '', description: '', platforms: [], material_id: '', content_type: 'video' }); loadContents() }
      else alert(data.error || '创建失败')
    } catch (e) { alert('创建失败') }
  }
  const handlePublish = async (contentId, platform) => {
    try {
      const res = await fetch(API_BASE + '/ip-operations/contents/' + contentId + '/publish', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ platform })
      })
      const data = await res.json()
      if (data.success) { alert('发布任务已创建！'); loadContents() }
      else alert(data.error || '发布失败')
    } catch (e) { alert('发布失败') }
  }
  const togglePlatform = (p) => {
    setContentForm(prev => ({
      ...prev,
      platforms: prev.platforms.includes(p) ? prev.platforms.filter(x => x !== p) : [...prev.platforms, p]
    }))
  }

  const cardStyle = { border: '1px solid #eee', borderRadius: '8px', padding: '16px', background: 'white' }
  const btnBlue = { padding: '6px 16px', background: '#1890ff', color: 'white', border: 'none', borderRadius: '6px', cursor: 'pointer' }
  const btnGray = { padding: '6px 16px', background: '#999', color: 'white', border: 'none', borderRadius: '6px', cursor: 'pointer' }
  const btnRed = { padding: '4px 12px', background: '#ff4d4f', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer', fontSize: '12px' }

  return (
    <div style={{ padding: '24px', maxWidth: '1200px', margin: '0 auto' }}>
      <div style={{ marginBottom: '24px' }}>
        <h1 style={{ fontSize: '24px', fontWeight: 'bold', marginBottom: '8px' }}>📺 IP运营中心</h1>
        <p style={{ color: '#666' }}>统一管理抖音、小红书、视频号内容分发</p>
      </div>

      <div style={{ display: 'flex', gap: '8px', marginBottom: '24px', borderBottom: '1px solid #eee', paddingBottom: '8px' }}>
        {[{ key: 'platforms', label: '📱 平台账号', count: platforms.length },
          { key: 'materials', label: '📁 素材库', count: materials.length },
          { key: 'templates', label: '📋 IP模板', count: 8 },
          { key: 'video-templates', label: '🎬 视频模板', count: 10 },
          { key: 'growth-templates', label: '🌟 成长记录', count: 5 },
          { key: 'activity-templates', label: '📋 活动方案', count: 3 },
          { key: 'contents', label: '📝 内容管理', count: contents.length }].map(tab => (
          <button key={tab.key} onClick={() => setActiveTab(tab.key)} style={{
            padding: '8px 16px', border: 'none', borderRadius: '6px', cursor: 'pointer',
            fontWeight: activeTab === tab.key ? 'bold' : 'normal',
            background: activeTab === tab.key ? '#1890ff' : '#f5f5f5',
            color: activeTab === tab.key ? 'white' : '#333'
          }}>
            {tab.label} ({tab.count})
          </button>
        ))}
      </div>

      {/* 平台账号 */}
      {activeTab === 'platforms' && (
        <div>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
            <h2 style={{ fontSize: '18px', fontWeight: 600 }}>平台账号管理</h2>
            <button onClick={() => setShowAddPlatform(true)} style={btnBlue}>+ 添加平台</button>
          </div>
          {showAddPlatform && (
            <div style={{ background: '#f5f5f5', padding: '20px', borderRadius: '8px', marginBottom: '16px' }}>
              <h3 style={{ marginBottom: '16px' }}>添加平台账号</h3>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
                <div>
                  <label style={{ display: 'block', marginBottom: '4px', fontSize: '13px' }}>平台</label>
                  <select value={platformForm.platform} onChange={e => setPlatformForm(p => ({ ...p, platform: e.target.value }))} style={{ width: '100%', padding: '8px', borderRadius: '4px', border: '1px solid #ddd' }}>
                    <option value="douyin">🎵 抖音</option>
                    <option value="xiaohongshu">📕 小红书</option>
                    <option value="video">🎬 微信视频号</option>
                  </select>
                </div>
                <div>
                  <label style={{ display: 'block', marginBottom: '4px', fontSize: '13px' }}>账号名称</label>
                  <input value={platformForm.name} onChange={e => setPlatformForm(p => ({ ...p, name: e.target.value }))} placeholder="如：博小兔官方号" style={{ width: '100%', padding: '8px', borderRadius: '4px', border: '1px solid #ddd' }} />
                </div>
                <div>
                  <label style={{ display: 'block', marginBottom: '4px', fontSize: '13px' }}>App ID / 抖音号</label>
                  <input value={platformForm.app_id} onChange={e => setPlatformForm(p => ({ ...p, app_id: e.target.value }))} placeholder="平台App ID" style={{ width: '100%', padding: '8px', borderRadius: '4px', border: '1px solid #ddd' }} />
                </div>
                <div>
                  <label style={{ display: 'block', marginBottom: '4px', fontSize: '13px' }}>App Secret</label>
                  <input type="password" value={platformForm.app_secret} onChange={e => setPlatformForm(p => ({ ...p, app_secret: e.target.value }))} placeholder="平台密钥" style={{ width: '100%', padding: '8px', borderRadius: '4px', border: '1px solid #ddd' }} />
                </div>
              </div>
              <div style={{ display: 'flex', gap: '8px', marginTop: '12px' }}>
                <button onClick={handleAddPlatform} style={btnBlue}>保存</button>
                <button onClick={() => setShowAddPlatform(false)} style={btnGray}>取消</button>
              </div>
            </div>
          )}
          {platforms.length === 0 ? (
            <div style={{ textAlign: 'center', padding: '40px', color: '#999', background: '#fafafa', borderRadius: '8px' }}>暂无平台账号，点击上方添加</div>
          ) : (
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))', gap: '16px' }}>
              {platforms.map(p => (
                <div key={p.id} style={{ ...cardStyle }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '12px' }}>
                    <span style={{ fontSize: '32px' }}>{PLATFORM_LOGOS[p.platform] || '📱'}</span>
                    <div>
                      <div style={{ fontWeight: 'bold', fontSize: '16px' }}>{p.name || PLATFORM_NAMES[p.platform]}</div>
                      <div style={{ fontSize: '12px', color: '#999' }}>{PLATFORM_NAMES[p.platform]}</div>
                    </div>
                    <span style={{ marginLeft: 'auto', padding: '2px 8px', borderRadius: '10px', fontSize: '12px', background: p.status === 'active' ? '#e6f7e6' : '#f5f5f5', color: p.status === 'active' ? '#52c41a' : '#999' }}>
                      {STATUS_LABELS[p.status] || p.status}
                    </span>
                  </div>
                  {p.app_id && <div style={{ fontSize: '12px', color: '#666', marginBottom: '4px' }}>ID: {p.app_id}</div>}
                  <div style={{ fontSize: '12px', color: '#999', marginTop: '12px' }}>创建: {p.created_at ? new Date(p.created_at).toLocaleDateString() : '-'}</div>
                  <button onClick={() => handleDeletePlatform(p.id)} style={{ ...btnRed, marginTop: '8px' }}>删除</button>
                </div>
              ))}
            </div>
          )}
        </div>
      )}

      {/* 素材库 */}
      {activeTab === 'templates' && (
        <div>
          <h2 style={{ fontSize: '18px', fontWeight: 600, marginBottom: '16px' }}>📋 创始人IP内容模板</h2>
          <p style={{ color: '#666', marginBottom: '20px' }}>基于创始人IP打造的8大内容模板，覆盖不同场景，点击"使用"可直接创建内容</p>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '16px' }}>
            {FOUNDER_TEMPLATES.map(t => (
              <div key={t.id} style={{ background: '#fff', borderRadius: '12px', padding: '20px', boxShadow: '0 2px 12px rgba(0,0,0,0.08)' }}>
                <div style={{ fontSize: '16px', fontWeight: 600, marginBottom: '8px', color: '#333' }}>{t.name}</div>
                <div style={{ fontSize: '13px', color: '#666', marginBottom: '8px' }}>{t.desc}</div>
                <div style={{ fontSize: '12px', color: '#999', marginBottom: '12px' }}>⏱ {t.duration}</div>
                <div style={{ fontSize: '11px', color: '#1890ff', marginBottom: '12px' }}>📌 {t.scenes.join(' → ')}</div>
                <button onClick={() => { setContentForm({...contentForm, title: t.name, description: t.desc}); setActiveTab('contents') }} style={{ width: '100%', padding: '8px 12px', background: '#1890ff', color: '#fff', border: 'none', borderRadius: '6px', cursor: 'pointer', fontSize: '13px' }}>使用此模板</button>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* 视频模板 */}
      {activeTab === 'video-templates' && (
        <div>
          <h2 style={{ fontSize: '18px', fontWeight: 600, marginBottom: '16px' }}>🎬 博小兔10大视频模板</h2>
          <p style={{ color: '#666', marginBottom: '20px' }}>专业成长记录模板，覆盖年度回顾、活动集锦、成就展示等场景</p>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '16px' }}>
            {VIDEO_TEMPLATES.map(t => (
              <div key={t.id} style={{ background: '#fff', borderRadius: '12px', padding: '20px', boxShadow: '0 2px 12px rgba(0,0,0,0.08)' }}>
                <div style={{ fontSize: '14px', fontWeight: 600, marginBottom: '8px', color: '#333' }}>{t.id} {t.name}</div>
                <div style={{ fontSize: '13px', color: '#666', marginBottom: '8px' }}>{t.desc}</div>
                <div style={{ fontSize: '12px', color: '#52c41a', marginBottom: '12px' }}>⏱ {t.duration}</div>
                <div style={{ fontSize: '11px', color: '#999', marginBottom: '12px' }}>📌 {t.scenes.join(' → ')}</div>
                <button onClick={() => alert('视频模板制作功能开发中')} style={{ width: '100%', padding: '8px 12px', background: '#52c41a', color: '#fff', border: 'none', borderRadius: '6px', cursor: 'pointer', fontSize: '13px' }}>制作视频</button>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* 成长记录模板 */}
      {activeTab === 'growth-templates' && (
        <div>
          <h2 style={{ fontSize: '18px', fontWeight: 600, marginBottom: '16px' }}>🌟 成长记录模板</h2>
          <p style={{ color: '#666', marginBottom: '20px' }}>回忆视频风格模板，适合生成孩子的成长纪念视频</p>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '16px' }}>
            {GROWTH_TEMPLATES.map(t => (
              <div key={t.id} style={{ background: '#fff', borderRadius: '12px', padding: '20px', boxShadow: '0 2px 12px rgba(0,0,0,0.08)' }}>
                <div style={{ fontSize: '16px', fontWeight: 600, marginBottom: '8px', color: '#333' }}>{t.name}</div>
                <div style={{ fontSize: '13px', color: '#666', marginBottom: '8px' }}>{t.desc}</div>
                <div style={{ fontSize: '12px', color: '#722ed1', marginBottom: '12px' }}>⏱ {t.duration}</div>
                <button onClick={() => alert('成长记录制作功能开发中')} style={{ width: '100%', padding: '8px 12px', background: '#722ed1', color: '#fff', border: 'none', borderRadius: '6px', cursor: 'pointer', fontSize: '13px' }}>制作视频</button>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* 活动执行方案模板 */}
      {activeTab === 'activity-templates' && (
        <div>
          <h2 style={{ fontSize: '18px', fontWeight: 600, marginBottom: '16px' }}>📋 活动执行方案模板</h2>
          <p style={{ color: '#666', marginBottom: '20px' }}>总部统一制定的活动执行流程模板，自动推送家长</p>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '16px' }}>
            {ACTIVITY_TEMPLATES.map(t => (
              <div key={t.id} style={{ background: '#fff', borderRadius: '12px', padding: '20px', boxShadow: '0 2px 12px rgba(0,0,0,0.08)' }}>
                <div style={{ fontSize: '16px', fontWeight: 600, marginBottom: '8px', color: '#333' }}>{t.id} {t.name}</div>
                <div style={{ fontSize: '13px', color: '#666', marginBottom: '8px' }}>{t.desc}</div>
                <div style={{ fontSize: '12px', color: '#fa8c16', marginBottom: '12px' }}>⏱ {t.duration}</div>
                <div style={{ fontSize: '12px', color: '#999', marginBottom: '12px' }}>📌 执行阶段：{t.phases.join(' → ')}</div>
                <button onClick={() => alert('活动方案功能开发中')} style={{ width: '100%', padding: '8px 12px', background: '#fa8c16', color: '#fff', border: 'none', borderRadius: '6px', cursor: 'pointer', fontSize: '13px' }}>查看详情</button>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* 素材库 */}
      {activeTab === 'materials' && (
        <div>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
            <h2 style={{ fontSize: '18px', fontWeight: 600 }}>素材库</h2>
            <button onClick={() => setShowAddMaterial(true)} style={btnBlue}>+ 上传素材</button>
          </div>
          {showAddMaterial && (
            <div style={{ background: '#f5f5f5', padding: '20px', borderRadius: '8px', marginBottom: '16px' }}>
              <h3 style={{ marginBottom: '16px' }}>上传素材</h3>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '12px' }}>
                <div>
                  <label style={{ display: 'block', marginBottom: '4px', fontSize: '13px' }}>素材标题</label>
                  <input value={materialForm.title} onChange={e => setMaterialForm(m => ({ ...m, title: e.target.value }))} placeholder="素材名称" style={{ width: '100%', padding: '8px', borderRadius: '4px', border: '1px solid #ddd' }} />
                </div>
                <div>
                  <label style={{ display: 'block', marginBottom: '4px', fontSize: '13px' }}>类型</label>
                  <select value={materialForm.type} onChange={e => setMaterialForm(m => ({ ...m, type: e.target.value }))} style={{ width: '100%', padding: '8px', borderRadius: '4px', border: '1px solid #ddd' }}>
                    <option value="video">视频</option><option value="image">图片</option><option value="text">文案</option>
                  </select>
                </div>
                <div>
                  <label style={{ display: 'block', marginBottom: '4px', fontSize: '13px' }}>标签</label>
                  <input value={materialForm.tags} onChange={e => setMaterialForm(m => ({ ...m, tags: e.target.value }))} placeholder="如: 幼儿园,暑假" style={{ width: '100%', padding: '8px', borderRadius: '4px', border: '1px solid #ddd' }} />
                </div>
              </div>
              <div style={{ marginTop: '12px' }}>
                <label style={{ display: 'block', marginBottom: '4px', fontSize: '13px' }}>选择文件</label>
                <input type="file" onChange={e => setUploadFile(e.target.files[0])} style={{ padding: '8px', borderRadius: '4px', border: '1px solid #ddd', width: '100%' }} />
              </div>
              <div style={{ display: 'flex', gap: '8px', marginTop: '12px' }}>
                <button onClick={handleUploadMaterial} style={btnBlue}>上传</button>
                <button onClick={() => { setShowAddMaterial(false); setUploadFile(null) }} style={btnGray}>取消</button>
              </div>
            </div>
          )}
          {materials.length === 0 ? (
            <div style={{ textAlign: 'center', padding: '40px', color: '#999', background: '#fafafa', borderRadius: '8px' }}>暂无素材，点击上方上传</div>
          ) : (
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))', gap: '12px' }}>
              {materials.map(m => (
                <div key={m.id} style={{ ...cardStyle }}>
                  <div style={{ fontSize: '40px', textAlign: 'center', marginBottom: '8px' }}>{m.type === 'video' ? '🎬' : m.type === 'image' ? '🖼️' : '📝'}</div>
                  <div style={{ fontWeight: 'bold', fontSize: '14px', marginBottom: '4px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{m.title}</div>
                  <div style={{ fontSize: '12px', color: '#999' }}>{m.type} | {m.file_size ? (m.file_size / 1024 / 1024).toFixed(1) + 'MB' : '-'}</div>
                  {m.tags && <div style={{ fontSize: '11px', color: '#1890ff', marginTop: '4px' }}>{m.tags}</div>}
                  <div style={{ fontSize: '11px', color: '#999', marginTop: '4px' }}>{m.created_at ? new Date(m.created_at).toLocaleDateString() : '-'}</div>
                  <button onClick={() => handleDeleteMaterial(m.id)} style={{ ...btnRed, marginTop: '8px', width: '100%' }}>删除</button>
                </div>
              ))}
            </div>
          )}
        </div>
      )}

      {/* 内容管理 */}
      {activeTab === 'contents' && (
        <div>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
            <h2 style={{ fontSize: '18px', fontWeight: 600 }}>内容管理</h2>
            <button onClick={() => setShowAddContent(true)} style={btnBlue}>+ 创建内容</button>
          </div>
          {showAddContent && (
            <div style={{ background: '#f5f5f5', padding: '20px', borderRadius: '8px', marginBottom: '16px' }}>
              <h3 style={{ marginBottom: '16px' }}>创建内容</h3>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
                <div>
                  <label style={{ display: 'block', marginBottom: '4px', fontSize: '13px' }}>内容标题 *</label>
                  <input value={contentForm.title} onChange={e => setContentForm(c => ({ ...c, title: e.target.value }))} placeholder="视频标题" style={{ width: '100%', padding: '8px', borderRadius: '4px', border: '1px solid #ddd' }} />
                </div>
                <div>
                  <label style={{ display: 'block', marginBottom: '4px', fontSize: '13px' }}>内容类型</label>
                  <select value={contentForm.content_type} onChange={e => setContentForm(c => ({ ...c, content_type: e.target.value }))} style={{ width: '100%', padding: '8px', borderRadius: '4px', border: '1px solid #ddd' }}>
                    <option value="video">视频</option><option value="image">图文</option><option value="text">纯文字</option>
                  </select>
                </div>
                <div style={{ gridColumn: '1 / -1' }}>
                  <label style={{ display: 'block', marginBottom: '4px', fontSize: '13px' }}>发布平台 *</label>
                  <div style={{ display: 'flex', gap: '12px' }}>
                    {Object.entries(PLATFORM_NAMES).map(([key, name]) => (
                      <label key={key} style={{ display: 'flex', alignItems: 'center', gap: '4px', cursor: 'pointer' }}>
                        <input type="checkbox" checked={contentForm.platforms.includes(key)} onChange={() => togglePlatform(key)} />
                        {PLATFORM_LOGOS[key]} {name}
                      </label>
                    ))}
                  </div>
                </div>
                <div style={{ gridColumn: '1 / -1' }}>
                  <label style={{ display: 'block', marginBottom: '4px', fontSize: '13px' }}>描述</label>
                  <textarea value={contentForm.description} onChange={e => setContentForm(c => ({ ...c, description: e.target.value }))} placeholder="内容描述..." rows={3} style={{ width: '100%', padding: '8px', borderRadius: '4px', border: '1px solid #ddd', resize: 'vertical' }} />
                </div>
              </div>
              <div style={{ display: 'flex', gap: '8px', marginTop: '12px' }}>
                <button onClick={handleCreateContent} style={btnBlue}>创建</button>
                <button onClick={() => setShowAddContent(false)} style={btnGray}>取消</button>
              </div>
            </div>
          )}
          {contents.length === 0 ? (
            <div style={{ textAlign: 'center', padding: '40px', color: '#999', background: '#fafafa', borderRadius: '8px' }}>暂无内容，点击上方创建</div>
          ) : (
            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
              {contents.map(c => {
                const cPlatforms = c.platforms ? JSON.parse(c.platforms) : []
                return (
                  <div key={c.id} style={{ ...cardStyle }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                      <div>
                        <div style={{ fontWeight: 'bold', fontSize: '16px', marginBottom: '8px' }}>{c.title}</div>
                        <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
                          {cPlatforms.map(p => (
                            <span key={p} style={{ padding: '2px 8px', background: '#e6f7ff', color: '#1890ff', borderRadius: '10px', fontSize: '12px' }}>{PLATFORM_LOGOS[p]} {PLATFORM_NAMES[p]}</span>
                          ))}
                        </div>
                        {c.description && <div style={{ fontSize: '12px', color: '#999', marginTop: '8px' }}>{c.description.substring(0, 100)}{c.description.length > 100 ? '...' : ''}</div>}
                      </div>
                      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: '8px' }}>
                        <span style={{ padding: '2px 8px', borderRadius: '10px', fontSize: '12px', background: STATUS_COLORS[c.status] ? '#e6f7e6' : '#f5f5f5', color: STATUS_COLORS[c.status] || '#999' }}>
                          {STATUS_LABELS[c.status] || c.status}
                        </span>
                        {c.status === 'draft' && cPlatforms.length > 0 && cPlatforms.map(p => (
                          <button key={p} onClick={() => handlePublish(c.id, p)} style={{ padding: '4px 12px', background: '#52c41a', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer', fontSize: '12px' }}>
                            发布到{PLATFORM_NAMES[p]}
                          </button>
                        ))}
                      </div>
                    </div>
                    <div style={{ fontSize: '11px', color: '#999', marginTop: '8px' }}>创建: {c.created_at ? new Date(c.created_at).toLocaleDateString() : '-'}</div>
                  </div>
                )
              })}
            </div>
          )}
        </div>
      )}
    </div>
  )
}
